import { CommandProps, Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { AudioBlockDataItem, BlockTypes } from '../../../../models';
import { AudioNodeView } from './AudioNodeView';

interface AudioProps {
  items: AudioBlockDataItem[];
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    audioNode: { insertAudioNode: ({ items }: AudioProps) => ReturnType };
  }
}

export const AudioNode = Node.create({
  name: 'audioNode',
  group: 'block',
  atom: true,

  addAttributes() {
    return { items: [], pastedFiles: [] };
  },

  parseHTML() {
    return [{ tag: BlockTypes.audio }];
  },

  renderHTML({ HTMLAttributes }) {
    return [BlockTypes.audio, mergeAttributes(HTMLAttributes)];
  },

  addCommands() {
    return {
      insertAudioNode:
        ({ items }: AudioProps) =>
        ({ commands }: CommandProps) => {
          return commands.insertContent({ type: this.name, attrs: { items } });
        },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(AudioNodeView);
  },
});
